"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils/utils");

var _biLogger = require("@wix/photography-client-lib/dist/src/utils/biLogger");

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenSocialDownload =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenSocialDownload, _React$Component);

  function FullscreenSocialDownload(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FullscreenSocialDownload.prototype;

  _proto.onKeyPress = function onKeyPress(e, downloadLink) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();

        if (_utils.utils.isiOS()) {
          _windowWrapper["default"].open(downloadLink);
        } else {
          _windowWrapper["default"].open(downloadLink, '_blank');
        }

        if (_utils.utils.isOOI() && this.props.biLogger) {
          this.props.biLogger.trackBi('download', {
            origin: 'fullscreen'
          });
        } else {
          _biLogger.logger.track('download', {
            origin: 'fullscreen'
          });
        }

        return false;
    }
  };

  _proto.onKeyPressText = function onKeyPressText(e, curItem) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();
        this.props.itemActions.downloadTextItem(curItem);
        return false;
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var arrowImageClass = 'progallery-svg-font-icons-download' + (this.props.hasAdditionalNavbarElement ? '-store' : '');
    var _this$props = this.props,
        layout = _this$props.layout,
        device = _this$props.device,
        current = _this$props.current,
        styleParams = _this$props.styleParams;
    var curItem = current.item;
    var downloadUrl = styleParams.isStoreGallery ? 'download_sample' : 'download';
    var downloadLink = curItem.createUrl(downloadUrl, 'video') || curItem.createUrl(downloadUrl, 'img');
    var downloadClassNames = ["fullscreen-social-download " + arrowImageClass, this.props.itemActions.viewClassName(layout, device), 'has-custom-focus'].join(' ') + (_utils.utils.isMobile ? ' pro-fullscreen-mobile-social-icon' : '');
    return styleParams.allowDownload && !curItem.isDemo ? curItem.isText ? _react["default"].createElement("a", {
      className: downloadClassNames,
      style: this.props.style,
      tabIndex: 0,
      "aria-label": "Download " + curItem.type + " to your device",
      role: "button",
      title: 'Download',
      onClick: function onClick(evt) {
        evt.stopPropagation();

        _this2.props.itemActions.downloadTextItem(curItem);
      },
      onKeyDown: function onKeyDown(e) {
        return _this2.onKeyPressText(e, curItem);
      }
    }) : _react["default"].createElement("a", {
      className: downloadClassNames,
      style: this.props.style,
      tabIndex: 0,
      "aria-label": "Download " + curItem.type + " to your device",
      role: "button",
      href: downloadLink,
      download: "download",
      title: 'Download',
      target: "_blank",
      onClick: function onClick(e) {
        e.preventDefault();

        if (_utils.utils.isiOS()) {
          _windowWrapper["default"].open(downloadLink);
        } else {
          _windowWrapper["default"].open(downloadLink, '_blank');
        }

        if (_utils.utils.isOOI() && _this2.props.biLogger) {
          _this2.props.biLogger.trackBi('download', {
            origin: 'fullscreen'
          });
        } else {
          _biLogger.logger.track('download', {
            origin: 'fullscreen'
          });
        }
      },
      onKeyDown: function onKeyDown(e) {
        return _this2.onKeyPress(e, downloadLink);
      }
    }) : false;
  };

  return FullscreenSocialDownload;
}(_react["default"].Component);

var _default = FullscreenSocialDownload;
exports["default"] = _default;